import { createIcon } from '../icon'
import CartIconNew from '../svg/CartIconNew'

export const CartIconNewDefault = createIcon(CartIconNew)
